import * as React from 'react';
import { useTheme } from '../../../../../theme';
import cn from 'classnames';
import { ListOption } from '@shared/ui/List';

interface Props {
	className?: string;
	options: ListOption[];
	value?: ListOption;
	withSeparator?: boolean;
	dataTestId?: string;
	onChange: (option: ListOption) => void;
}

const List: React.FC<Props> = ({ className, options, value, withSeparator, dataTestId, onChange }) => {
	const { List: theme } = useTheme('Shared');

	return (
		<div className={cn(theme.root, className)} role="listbox" data-test-id={dataTestId}>
			{options.map((option, index) => (
				<React.Fragment key={option.value}>
					{index !== 0 && withSeparator && <div className={theme.separator} />}
					<div
						className={cn(theme.option, {
							[theme.selected]: option.value === value?.value
						})}
						data-sort={option.dataSort}
						onClick={() => onChange(option)}
						role="option"
						aria-selected={option.value === value?.value}
					>
						{!!option.icon && <div className={theme.icon}>{option.icon}</div>}
						<div className={theme.label}>{option.label}</div>
					</div>
				</React.Fragment>
			))}
		</div>
	);
};

export default List;
